import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageBanner from "../components/PageBanner";
import { Col, Row } from "antd";


const PhonToWeb = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const bannerData = {
    image: "/images/services/phone-to-web-banner.jpg",
    heading: "Phone To Web",
    para: "   In the field of market research, the shift from conventional telephone surveys to the dynamic world of online surveys has revolutionized the manner in which companies collect valuable insights.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>Phone to Web Integration - Seamless Data Collection | Poll Sphere</title>
        <meta
          name="description"
          content="Enhance your research with Poll Sphere's Phone to Web services, seamlessly bridging telephonic and online data collection. This integrated approach offers a flexible, efficient way to enrich your insights, combining the depth of CATI with the breadth of CAWI. Perfect for comprehensive market analysis and understanding diverse consumer perspectives."
        />
      </Helmet>
      <PageBanner {...bannerData} />
      

      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">

           <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/phone-interview.jpg" alt="" />
              </div>
            </Col>
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> Phone Interview</h2>
                <p>
                The survey commences with a telephone interview carried out by a live interviewer who poses questions to elicit responses from the participant during the conversation.
                </p>
              </div>
            </Col>
             
          </Row>
        </div>
      </section>
      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">

           
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> Transition to Web Survey</h2>
                <p>
                
Following the conclusion of the phone interview, participants are informed of the opportunity to proceed with the survey online. They are furnished with guidelines on how to access the web-based survey.
                </p>
              </div>
            </Col>
             <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/web-survey.jpg" alt="" />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">

           <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/setup-survey.jpg" alt="" />
              </div>
            </Col>
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> Web Survey Setup</h2>
                <p>
                The online survey is established through the utilization of an online survey platform, such as Qualtrics, SurveyMonkey, or a customized proprietary system. The questions that were posed during the phone interview are duplicated in the web-based survey.
                </p>
              </div>
            </Col>
             
          </Row>
        </div>
      </section>
      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">

           
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> Participant Authentication</h2>
                <p>
                In order to maintain data integrity, participants might be asked to verify their identity on the web survey platform. This can be achieved through the use of distinct login credentials or alternative verification techniques.
                </p>
              </div>
            </Col>
             <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/participant.jpg" alt="" />
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className="py-50">
      <div className="container">
        <Row align="middle" className="content-main-wrapper">

         <Col md={12}>
            <div className="img-wrapper">
              <img src="images/services/setup-survey.jpg" alt="" />
            </div>
          </Col>
          <Col md={12}>
            <div className="content-wrapper px-50">
              <h2> Online Survey Completion</h2>
              <p>
              Participants access the web survey following the provided instructions and proceed to answer the remaining questions online. They input their responses directly into the online survey form.
              </p>
            </div>
          </Col>
           
        </Row>
      </div>
    </section>
    <section className="py-50">
      <div className="container">
        <Row align="middle" className="content-main-wrapper">

         
          <Col md={12}>
            <div className="content-wrapper px-50">
              <h2> Data Integration</h2>
              <p>
              Upon participants' completion of the web survey, their responses are automatically gathered and seamlessly integrated into the survey dataset. This guarantees a smooth amalgamation of both phone and web survey data.
              </p>
            </div>
          </Col>
           <Col md={12}>
            <div className="img-wrapper">
              <img src="images/services/Integration.jpg" alt="" />
            </div>
          </Col>
        </Row>
      </div>
    </section>
    <section className="py-50">
    <div className="container">
      <Row align="middle" className="content-main-wrapper">

       <Col md={12}>
          <div className="img-wrapper">
            <img src="images/services/analysis.jpg" alt="" />
          </div>
        </Col>
        <Col md={12}>
          <div className="content-wrapper px-50">
            <h2> Data Analysis</h2>
            <p>
            Subsequently, the collected data is prepared for analysis. Researchers can employ statistical analysis software or other suitable tools to scrutinize the merged dataset, extracting insights and formulating conclusions from the accumulated responses.
            </p>
          </div>
        </Col>
         
      </Row>
    </div>
  </section>
  

  
    </div>
  );
};

export default PhonToWeb;
